import React from "react";
import "./TicketView.css";
import images from "../../../Utils/importImages";
import { useNavigate } from "react-router-dom";

import TicketFormat from "./TicketFormat";

function TicketView({ Data ,  ticketRef}) {
  let navigate = useNavigate();

  console.log("Inside Data is : ", Data);

  return (
    <TicketFormat
     ref={ticketRef}
      Data={Data}
      nav={
        <div
          className="back-arrow"
          onClick={() => navigate("/user/myflightbookings")}
        >
          <img src={images["back-arrow.svg"]} alt="" />
          <div className="proxima_regular font16 color_endeavour">Back</div>
        </div>
      }
    />
  );
}

export default TicketView;
